import { registerComponent } from 'lib/react_on_rails';

import ApplySignUp from 'participant/apply/apply_sign_up';

// oxlint-disable-next-line local-rules/css_modules
import 'participant/apply/apply_success.css';

registerComponent('ApplySignUp', ApplySignUp);
